import React, {useContext} from 'react'
import {Grid} from '@material-ui/core'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';

import useStyles from './styles'
import AppButton from '../../Common/AppButton'
import PriorAuthorizationContext from "../../../contexts/PriorAuthorization/PriorAuthorization.context";

export default function CancelSuccess(props){

    const { setState, inquiry: {rootOperation} } = useContext(PriorAuthorizationContext);
    const {...wrapperProps} = props
    const classes = useStyles()

    const goBack = () => {
        setState( prev => {
            return {
                ...prev,
                bannerProps:{
                    message: null
                },
                operation: rootOperation,
                inquiry: {
                    ...prev.inquiry,
                    view: 'results'
                }
            }
        })
    }

    return (
        <div {...wrapperProps} style={{width: '100%', height: '100%', ...wrapperProps.style}}>
            <Grid style={{width: '100%', height: '50%', marginTop: '3rem'}} container spacing={0} justify='center' >
                
                <Grid className={classes.checkIconWrapper} container justify='center' item xs={12}>
                    <CheckCircleOutlineIcon className={classes.checkIcon} />
                </Grid>
                
                <Grid container justify='center' item xs={12} className={classes.message}>
                    PA cancellation request successfully submitted,<br/>please allow 24 hours for this request to process.
                </Grid>

                <Grid className={classes.buttonWrapper} container justify='center' item xs={12}>
                    <AppButton
                        style={{width: 'fit-content'}}
                        className='btn-primary' 
                        text='CONTINUE' 
                        size='large'
                        onClick={goBack}
                        buttonStyle={{width: '13rem', height: '3rem', fontSize: '1rem'}}
                    >
                    </AppButton>
                </Grid>

            </Grid>
        </div>
    )
}